var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "select-layout-modal",
        title: "Select Layout Images",
        size: "lg",
        "ok-only": "",
        "ok-disabled": !_vm.selectedItems.length,
      },
      on: {
        ok: _vm.handleOkClick,
        show: function ($event) {
          return _vm.getLayouts("shown")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "layouts-table" },
        _vm._l(_vm.layouts.items, function (layout) {
          return _c(
            "div",
            {
              key: `layout_${layout.id}`,
              staticClass: "item-main-block position-relative",
              on: {
                click: function ($event) {
                  return _vm.showLayoutPreviewModal(layout)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column align-items-center p-1 layout-item",
                },
                [
                  _c("div", { staticClass: "layout-box" }, [
                    _c("img", {
                      attrs: {
                        src: `/share?file=${layout.thumbnail}`,
                        alt: "layout-thumbnail",
                      },
                      on: {
                        error: (event) =>
                          (event.target.src = "/images/image.svg"),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center name-container" }, [
                    _c("p", [_vm._v(_vm._s(_vm.getTrimFileName(layout.name)))]),
                  ]),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("VuePagination", {
        attrs: {
          pagination: _vm.layouts,
          offset: 2,
          "class-name": "layouts-pagination",
        },
        on: {
          "update:pagination": function ($event) {
            _vm.layouts = $event
          },
          paginate: function ($event) {
            return _vm.getLayouts()
          },
        },
      }),
      _vm._v(" "),
      _c("SelectImageToAnalyseModal", {
        ref: "layoutPreviewModal",
        on: { onSelectedItems: _vm.addLayoutLayersFlow },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }